import React from "react";
import { useMantineTheme, Text } from '@mantine/core';

import { numberWithComma } from "../../utils/globalFunctions";

import InputComponent from "../general/InputComponent";

const BarangDPBiayaDibatalkan = ({ stateData }) => {

    const theme = useMantineTheme();

    return (
        <React.Fragment>
            <InputComponent
                stateId={stateData.data.id}
                stateWithAsterisk={stateData.data.withAsterisk}
                stateLabel={stateData.data.label}
                stateDescription={stateData.data.description}
                statePlaceHolder={stateData.data.placeholder}
                stateReadOnly={true}
                stateValue={numberWithComma(stateData.data.value)}
                stateError={stateData.data.error}
                stateStylesInput={{
                    backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[7]
                }}
                stateIcon={<Text size='sm'>Rp</Text>}
            />
        </React.Fragment>
    )
}

export default BarangDPBiayaDibatalkan;